 import axios from "axios";
 import {BASE_URL as baseURL} from "../../api/apiClient";

 export default axios.create({baseURL,})
